module.exports = [ '$scope', 'railsResource', '$routeParams', '$location', 'feeSchedule', '$rootScope', '$window', '$filter', 'History', 'Accounts', 'InvestmentAccount', 'StaffInvestmentAccount', 'Transactions', 'users',
function($scope, $resource, $routeParams, $location, feeSchedule, $rootScope, $window, $filter, History, Accounts, InvestmentAccount, StaffInvestmentAccount, Transactions, users) {

  this.loadAccount = () => {
    Accounts.get({ id: $routeParams.id, basic: true }, account => {
      this.account = account;
      this.allowNameEdit = account.status != 4
      this.inceptionData = account;
      this.sortedAssetClasses = _.sortBy(this.inceptionData.assetClassAllocation, 'amount').reverse();
    });

    Transactions.query({ id: $routeParams.id, limit: 5, recent: true }, transactions => {
      this.recentTransactions = transactions;
    });
  };

  this.loadAccount();

  this.newDepositPath = `/app/transfers/new?investmentAccountId=${$routeParams.id}&category=deposit`;

  this.goToExportTransactions = id => {
    window.location = `/app/export_transactions/${id}`;
  };

  this.user = users.getCurrentUser();

  this.showTransferFunds = () => {
    if (!this.user || !this.account) return false;
    return !this.user.isGroupPlanUser || !['group_rrsp', 'group_tfsa'].includes(this.account.accountType);
  };


  this.yDomain = function(data) {
    const values = _.map(data, 'value');
    const maxValue = _.max(values);
    const minValue = _.min(values);
    const spread = maxValue - minValue;
    values.push(maxValue + (spread * 0.15));
    return values;
  };

  this.triggerNameEdit = () => {
    this.editingName = true;
    this.oldAccountName = this.account.name;
  };

  this.finishNameEdit = () => {
    this.editingName = false;
    if (this.oldAccountName === this.account.name) { return; }

    this.updatingName = true;
    InvestmentAccount.updateName({ id: $routeParams.id, name: this.account.name }, () => {
      this.updatingName = false;
    });
  };

  this.delink = () => InvestmentAccount.delink({ id: $routeParams.id }, investment_account => {
    $window.history.back();
  });

  this.archive = () => StaffInvestmentAccount.handleArchive({ id: $routeParams.id, archive_status: true }, () => {
    window.location = `/app/clients/${this.account.userId }`;
  });

  this.unarchive = () => StaffInvestmentAccount.handleArchive({ id: $routeParams.id, archive_status: false }, () => {
    window.location = `/app/clients/${this.account.userId }`;
  });

  const unpackHistory = function(dataPoint) {
    dataPoint.date = moment(dataPoint.date).toDate();
    return dataPoint;
  };

  $scope.$watch('ctrl.range', range => {
    if (range == null) { return; }
    this.loaded = false;

    this.hideDetails();
    Accounts.get(_.merge($routeParams, range, { basic: true }), a => {
      this.dashboard = a;
      this.loaded = true;
    });

    History.query(_.merge($routeParams, range), history => {
      this.history = _.map(history, unpackHistory);
    });
  });

  // Chart Details Related
  $scope.$on('chartClicked', (e, details) => {
    this.selectedTab = 'details';
    this.chartDetails = details;
  });

  $scope.$on('overlayHidden', e => {
    this.chartDetails = undefined;
    this.selectedTab = 'performance';
  });

  let hidingDetails = false;
  this.showDetails = () => {
    if (!hidingDetails) { this.selectedTab = 'details'; }
    hidingDetails = false;
  };

  this.hideDetails = () => {
    this.chartDetails = undefined;
    this.selectedTab = 'performance';
    hidingDetails = true;
    $scope.$broadcast('detailsHidden');
  };

  return this;
}];
